// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-8b4e1d52]{display:none}.rating-stars-bar-container[data-v-8b4e1d52]{display:flex;align-items:center}.rating-stars-bar-star[data-v-8b4e1d52]{cursor:pointer}.invalid[data-v-8b4e1d52]  path{stroke:#ea0c27}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
